import React from "react";
import PaymentDistributionTable, { MobilePaymentDistributionTableRow, PaymentDistributionTableRow } from "components/pages/ParticipantDetailsPage/components/PaymentDistributionTable";

import "./styles.css";
import "./mobile.css";

/**
 * @function PaymentDistributionWidget
 * @return {React.Component}
 * @exported true
 * @description The is the PaymentDistributionWidget for ParticipantDetailsPage;
 */
export default function PaymentDistributionWidget(props) {
    return (
        <div className="payment-distribution-widget">
            <h2 className="widget-header">Payment Distribution</h2>
            <div className="show-on-desktop">
                <PaymentDistributionTable>
                    <PaymentDistributionTableRow />
                </PaymentDistributionTable>
            </div>
            <div className="show-on-mobile">
                <div className="mobile-payment-distribution-table">
                    <MobilePaymentDistributionTableRow />
                </div>
            </div>
        </div>
    )
}
